import AvatarContainer, { AvatarVariant } from '~/shared/components/Avatar';

interface UserAvatarProps {
  username: string;
  size?: AvatarVariant;
}

export default function UserAvatar({ username, size = 'md' }: UserAvatarProps) {
  const initials = (
    username.split(' ').length === 1 ? [username, username.substring(1, 2)] : username.split(' ')
  )
    .map((s) => s.substring(0, 1))
    .join('');

  return (
    <AvatarContainer variant={size} className="">
      <div className="uppercase text-white">{initials}</div>
    </AvatarContainer>
  );
}
